import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import messagePng from '@/shared/assets/png/message.png';
import { apiConfig, request } from '@/shared/io';
import { Avatar, Badge } from 'antd';
import { isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import styles from './index.module.less';
import { systemInfoQuery } from '@/shared/services';
import { MessageModal } from '@/shared/system/message/MessageModal';
import { useSharedGlobalState } from '@/shared/hooks';
let openChildWindowId = undefined;
const getInBoxEnums = () => {
    const pt = sessionStorage.getItem('pt');
    let userInfo = sessionStorage.getItem('USER_INFO') ?? '';
    if (userInfo) {
        userInfo = JSON.parse(userInfo) ?? {};
    }
    // 站内信订阅
    let inboxSubUrl = `/wstopic/inbox/${pt}/${userInfo.id}`;
    if (userInfo.defaultCompId && userInfo.defaultCompId !== '0') {
        inboxSubUrl += `/${userInfo.defaultCompId}`;
    }
    // 站内信订阅 全局订阅
    const allBox = `/wstopic/inbox/${pt}/${userInfo.id}/0`;
    return [inboxSubUrl, allBox];
};
const HeaderMessage = ({ avatarClass = '', textClass, }) => {
    const [messageNum, setMessageNum] = useState(0);
    const [messageRoutePath, setMessageRoutePath] = useState('');
    const [open, setOpen] = useState(false);
    // const wsContext: any = useContext(WebsocketContext);
    const { socketCtx: wsContext } = useSharedGlobalState();
    const getUnreadCountHandler = () => {
        // 未读消息数
        if (sessionStorage.getItem('ACCESS_TOKEN')) {
            request(`${apiConfig.apiMessage}/v1/mc/msg/records/total/info`).then((res) => {
                if (res.code == 200) {
                    let total = 0;
                    res.data.MsgRecordsTotal.forEach((item) => {
                        total += Number(item.number);
                    });
                    setMessageNum(total);
                }
            });
        }
    };
    const getMessageSystemId = (cb) => {
        if (sessionStorage.getItem('ACCESS_TOKEN')) {
            // 获取系统ID
            const sysCode = 'message-center';
            systemInfoQuery({ code: sysCode }, {
                'depend-uri': '/api/message/v1/mc/msg/records/table',
                'depend-method': 'POST',
            }).then((res) => {
                if (res.code == 200) {
                    let basePath = res.data?.pcPath;
                    if (basePath) {
                        if (basePath.includes('/:id')) {
                            // 嵌入基座的跳转方式
                            basePath = basePath.replace(':id', res.data.id);
                        }
                        if (!basePath.startsWith('/')) {
                            basePath = '/' + basePath;
                        }
                        if (basePath.endsWith('/')) {
                            basePath = basePath.substring(0, basePath.length - 1);
                        }
                        basePath = basePath + '/messageList';
                        cb?.(basePath);
                        setMessageRoutePath(basePath);
                    }
                }
            });
        }
    };
    const toMessagePath = () => {
        // 先关闭子窗口
        openChildWindowId?.close?.();
        if (isEmpty(messageRoutePath)) {
            getMessageSystemId((path) => {
                if (window.location.pathname != path) {
                    openChildWindowId = window.open(path, '_blank');
                }
            });
            return;
        }
        if (window.location.pathname != messageRoutePath) {
            openChildWindowId = window.open(messageRoutePath, '_blank');
        }
    };
    useEffect(() => {
        if (wsContext) {
            // 先取消订阅
            wsContext?.socketCloseSubscribe?.(getInBoxEnums());
            getUnreadCountHandler();
            // 订阅webscoket
            const subList = getInBoxEnums();
            wsContext?.socketSubscribe?.({
                receiveMessage: ({ subUrl }) => {
                    // console.log('receiveMessage:', subUrl)
                    if (subUrl && subList.includes(subUrl)) {
                        getUnreadCountHandler();
                    }
                },
            }, subList);
        }
        return () => {
            // 取消订阅
            wsContext?.socketCloseSubscribe?.(getInBoxEnums());
        };
    }, [wsContext]);
    useEffect(() => {
        getUnreadCountHandler();
        getMessageSystemId();
    }, []);
    return (_jsxs("a", { onClick: () => {
            setOpen(true);
        }, children: [_jsx(Badge, { size: "small", count: messageNum, className: `${styles.avatarBadge} ${messageNum >= 100 ? styles.avatarMultipleBadge : ''}`, children: _jsx(Avatar, { size: 16, src: messagePng, className: avatarClass, alt: "avatar" }) }), _jsx("span", { style: { marginLeft: '6px', color: 'rgba(255, 255, 255, 0.9)' }, className: `grid-header-mobile ${textClass || ''}`, children: "\u6D88\u606F\u901A\u77E5" }), _jsx(MessageModal, { bodyStyle: { maxHeight: '70%', padding: 0 }, title: "\u6D88\u606F\u4E2D\u5FC3", width: '90%', open: open, onCancel: (e) => {
                    console.log('onCancel');
                    e.stopPropagation();
                    setOpen(false);
                }, footer: null })] }));
};
export default HeaderMessage;
